// src/components/LlmProcessingCard/LlmFlowDiagram.js
import React, { useState } from "react";
import { Box } from "@mui/material";

import LlmFlowBlocks from "./LlmFlowDiagram/LlmFlowBlocks";
import LlmFlowDetails from "./LlmFlowDiagram/LlmFlowDetails";

/**
 * LlmFlowDiagram
 *
 * Generic flow visualiser composed from:
 *  - LlmFlowBlocks (horizontal block diagram with optional subunits)
 *  - LlmFlowDetails (details panel for the selected block/subunit)
 *
 * Props:
 *  - loading?: boolean (currently unused but reserved)
 *  - blocks: Array<{
 *      id: string;
 *      label: string;
 *      icon?: ReactNode;
 *      clickable?: boolean;
 *      phase?: "input" | "ai" | "output" | string;
 *      subunits?: Array<{ id: string; label: string }>;
 *    }>
 *  - detailsConfig: {
 *      [blockId: string]: {
 *        [subunitIdOrSelf: string]: {
 *          title?: string;
 *          description?: string;
 *          items?: string[];
 *        }
 *      }
 *    }
 */
export default function LlmFlowDiagram({
  loading = false, // eslint-disable-line no-unused-vars
  blocks,
  detailsConfig,
}) {
  const [selectedBlockId, setSelectedBlockId] = useState(null);
  const [selectedSubunitId, setSelectedSubunitId] = useState(null);

  const handleSelectBlock = (blockId) => {
    setSelectedBlockId(blockId);
    setSelectedSubunitId(null);
  };

  const handleSelectSubunit = (blockId, subunitId) => {
    setSelectedBlockId(blockId);
    setSelectedSubunitId(subunitId);
  };

  return (
    <Box
      sx={{
        mt: 2,
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <LlmFlowBlocks
        blocks={blocks}
        selectedBlockId={selectedBlockId}
        selectedSubunitId={selectedSubunitId}
        onSelectBlock={handleSelectBlock}
        onSelectSubunit={handleSelectSubunit}
      />

      <LlmFlowDetails
        selectedBlockId={selectedBlockId}
        selectedSubunitId={selectedSubunitId}
        detailsConfig={detailsConfig}
      />
    </Box>
  );
}
